// 增加区域字段
export const ZONESETTING = 'ZONESETTING';
// 当前选中字段
export const UPDATESELECTCARD = 'UPDATESELECTCARD';
// 更新区域列表
export const UPDATEAREALIST = 'UPDATEAREALIST';
//当前选中区域
export const UPDATESELECTAREA = 'UPDATESELECTAREA';
// 更新上传预览区域数据
export const PREVIEWDATA = 'PREVIEWDATA';
// 清空数据
export const CLEARDATA = 'CLEARDATA';
//切换公式编辑器
export const TOGGLEFORMULA = 'TOGGLEFORMULA';
//设置公式编辑器信息
export const SETFORMULAINFO = 'SETFORMULAINFO';
//设置批量设置表格dataSource
export const UPDATEBATCHSOURCE = 'UPDATEBATCHSOURCE';
//更新当前操作的批量设置单元格
export const SETCURRENTBATCHCELL = 'SETCURRENTBATCHCELL';
// 传递 区域 form 的区域值
export const SETZONEFORMFUN = 'SETZONEFORMFUN';
// 设置是否保存标示
export const UPDATESAVEFLAG = 'UPDATESAVEFLAG';
// 设置模板是否校验通过
export const SETAREAVALIDATE = 'SETAREAVALIDATE';
// 设置模板是否实施态
export const SETIMPLEMENTFLAG = 'SETIMPLEMENTFLAG';
// 设置区域 隐藏不显示属性
export const SETAREAVISIBLE = 'SETAREAVISIBLE';
// 标签布局模态框是否弹出
export const TABLAYMODALVISIBLE = "TABLAYMODALVISIBLE";
// 初始化 和 保存时才更新数据
export const SETSEVERDATA = "SETSEVERDATA"
// 设置区域 隐藏
export const SETAREAHIDE = "SETAREAHIDE"
// 设置选中的树节点
export const SET_META_TREE_NODES = 'SET_META_TREE_NODES';
// 设置searchbox 搜索的一些状态
export const UPDATE_SEARCH_BOX = "UPDATE_SEARCH_BOX";
// 切换左栏显隐
export const ONTOGGLELEFTSIDER = "ONTOGGLELEFTSIDER";
// 设置是否是移动模板
export const SETMOBILEFLAG = 'SETMOBILEFLAG';
// 设置是否是报表模板
export const SETREPORTFLAG = 'SETREPORTFLAG';